(ns manatee.components.notifications.subs
  (:require [manatee.components.notifications.db :as db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::announcements
 (fn [db _]
   (db/get-announcements db)))

(rf/reg-sub
 ::show-announcements?
 (fn [db _]
   (db/show-announcements? db)))

(rf/reg-sub
 ::alerts
 (fn [db [_ banner-id]]
   (db/get-alerts db banner-id)))
